import apiClient from './api'
import { withListDefaults } from '@/lib/listFetch'
import type {
  ApiResponse,
  ApiList,
  AppNotification,
  CompanyNotificationSettings,
  NotificationListQuery,
  NotificationSettings,
  NotificationSettingsRequest,
} from '@/types'

// 1:1 with Schema_Specification Section 4.12 (notifications — /notifications/*).
export const notificationsApi = {
  list: (q: NotificationListQuery = {}) =>
    apiClient
      .get<ApiList<AppNotification>>('/notifications', {
        params: withListDefaults(q),
      })
      .then(r => r.data),

  markRead: (id: string) =>
    apiClient
      .put<ApiResponse<AppNotification>>(`/notifications/${id}/read`)
      .then(r => r.data),

  delete: (id: string) =>
    apiClient
      .delete<ApiResponse<null>>(`/notifications/${id}`)
      .then(r => r.data),

  markAllRead: () =>
    apiClient
      .put<ApiResponse<{ updated: number }>>('/notifications/read-all')
      .then(r => r.data),

  getSettings: () =>
    apiClient
      .get<ApiResponse<NotificationSettings>>('/notifications/settings')
      .then(r => r.data),

  updateSettings: (body: NotificationSettingsRequest) =>
    apiClient
      .put<ApiResponse<NotificationSettings>>('/notifications/settings', body)
      .then(r => r.data),

  getCompanySettings: () =>
    apiClient
      .get<
        ApiResponse<CompanyNotificationSettings>
      >('/notifications/company-settings')
      .then(r => r.data),

  updateCompanySettings: (body: NotificationSettingsRequest) =>
    apiClient
      .put<
        ApiResponse<CompanyNotificationSettings>
      >('/notifications/company-settings', body)
      .then(r => r.data),
}

export default notificationsApi
